import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "kanban-lane-heading d-flex align-center flex-wrap" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["data-card"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_ontos_count = _resolveComponent("ontos-count")!
  const _component_ontos_person_line = _resolveComponent("ontos-person-line")!
  const _component_finished_period_menu = _resolveComponent("finished-period-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(["kanban-lane", _ctx.surfaceClass]),
    variant: "flat",
    border: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ontos_color_accent, {
        color: _ctx.lane.color
      }, null, 8, ["color"]),
      _createElementVNode("div", {
        class: _normalizeClass(["kanban-lane-header d-flex align-center px-3 py-2", _ctx.titleClass])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.lane.person)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "kanban-lane-person d-flex align-center mr-auto",
                title: _ctx.countTitle
              }, [
                _createVNode(_component_ontos_person_line, {
                  user: _ctx.lane.person.user,
                  name: _ctx.lane.person.name,
                  photo: _ctx.lane.person.photo
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ontos_count, {
                      count: _ctx.lane.instances.length,
                      hidden: _ctx.lane.hiddenCount
                    }, null, 8, ["count", "hidden"])
                  ]),
                  _: 1
                }, 8, ["user", "name", "photo"])
              ], 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("h3", {
                key: 1,
                class: "kanban-lane-title mr-auto",
                title: _ctx.countTitle
              }, [
                _createTextVNode(_toDisplayString(_ctx.lane.name) + " ", 1),
                _createVNode(_component_ontos_count, {
                  count: _ctx.lane.instances.length,
                  hidden: _ctx.lane.hiddenCount
                }, null, 8, ["count", "hidden"])
              ], 8, _hoisted_3)),
          (_ctx.lane.final)
            ? (_openBlock(), _createBlock(_component_finished_period_menu, {
                key: 2,
                value: _ctx.period,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('period-change', $event)))
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.canCreate)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "kanban-lane-create",
              variant: "text",
              icon: "",
              size: "small",
              title: _ctx.createLabel,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create', $event.currentTarget)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "small" }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-plus", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode(_component_draggable, _mergeProps({
        modelValue: _ctx.lane.instances,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lane.instances) = $event)),
        "item-key": "_instance",
        class: "kanban-lane-list px-1 px-sm-2"
      }, _ctx.settlingDrag, {
        disabled: !_ctx.canWrite,
        group: _ctx.group,
        filter: '.no-drag',
        "ghost-class": "ghost",
        delay: 150,
        "delay-on-touch-only": true,
        onPointerdown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pointerType = $event.pointerType)),
        onContextmenu: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onContextMenu($event))),
        onStart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('drag-start'))),
        onEnd: _cache[6] || (_cache[6] = ($event: any) => (_ctx.settleDrop($event))),
        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('change', $event)))
      }), {
        item: _withCtx(({ element }) => [
          _createElementVNode("div", {
            class: _normalizeClass({'no-drag': !_ctx.movable(element)}),
            "data-card": element._instance
          }, [
            _renderSlot(_ctx.$slots, "default", { instance: element }, undefined, true)
          ], 10, _hoisted_4)
        ]),
        _: 3
      }, 16, ["modelValue", "disabled", "group"])
    ]),
    _: 3
  }, 8, ["class"]))
}